<h2 lvrPadding [padHorizontal]="32" [padVertical]="0">{{ 'assignment.create_additional.title' | transloco }}</h2>

<form class="form-container" [formGroup]="form" lvrAutoSave="additional" [autoLoad]="false" [entityId]="draftId">
	<section class="form-grid">
		<!-- Start of the assignment -->
		@let startDateCtrl = form.get('startOfCare');
		<lvr-field [label]="'assignment.create_additional.startOfCare' | transloco">
			<mat-form-field lvrInput [lvrError]="hasError(startDateCtrl, 'minDateExceeded', 'maxDateExceeded')">
				<input
					matInput
					formControlName="startOfCare"
					[matDatepicker]="startPicker"
					placeholder="01.07.2025"
					[min]="minStartDate()"
					[max]="maxStartDate()"
					[errorStateMatcher]="matcher"
				/>
				@if (hasError(startDateCtrl, 'minDateExceeded')) {
					<mat-error>
						{{
							'assignment.create_additional.errors.min_date'
								| transloco: { min: (minStartDate() | date: dateDisplayFormat) }
						}}
					</mat-error>
				} @else if (hasError(startDateCtrl, 'maxDateExceeded')) {
					<mat-error>{{ 'assignment.create_additional.errors.max_date' | transloco }}</mat-error>
				} @else {
					<mat-hint>{{ dateFormatHint }}</mat-hint>
				}
				<mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
				<mat-datepicker #startPicker></mat-datepicker>
			</mat-form-field>
		</lvr-field>

		<!-- Type of care -->
		@let typeOfCareCtrl = form.get('categoryTypeOfCareId');
		<lvr-field [label]="'base.field.type_of_care' | transloco | appendAsterisk">
			<mat-form-field lvrInput [lvrError]="hasError(typeOfCareCtrl, 'required')">
				<mat-select
					formControlName="categoryTypeOfCareId"
					[placeholder]="'base.field.select_please' | transloco"
					aria-required="true"
				>
					@for (option of typesOfCare(); track option.id) {
						<mat-option [value]="option.id">
							{{ option.remark }}
						</mat-option>
					}
				</mat-select>
				@if (hasError(typeOfCareCtrl, 'required')) {
					<mat-error>{{ 'base.form.error.type_of_care_required' | transloco }}</mat-error>
				}
			</mat-form-field>
		</lvr-field>
		<div>
			<!-- Specialist -->
			@let participantsCtrl = form.get('participants');
			<lvr-participants
				style="padding-top: 8px"
				formControlName="participants"
				[label]="'assignment.create_additional.user' | transloco | appendAsterisk"
				[clientId]="client()?.id ?? 0"
				[clientFullName]="clientFullName()"
				[searchUsers]="false"
				[searchInstitutionPerson]="false"
				[useStaticResults]="true"
				[staticResults]="specialistSearchItems()"
				[userSpecializations]="userSpecializationsByObjectId()"
				[singleSelect]="true"
				[showCheckbox]="false"
				[showClientToggle]="false"
			>
			</lvr-participants>

			@if (hasError(participantsCtrl, 'required')) {
				<mat-error style="font-size: 12px">{{
					'assignment.create_additional.errors.user_required' | transloco
				}}</mat-error>
			} @else if (form.get('categoryTypeOfCareId')?.value && specialistSearchItems().length === 0) {
				<mat-error style="font-size: 12px">{{
					'assignment.create_additional.errors.no_users_for_type' | transloco
				}}</mat-error>
			}
		</div>

		<!-- Type of disability relevant to care -->
		<lvr-field [label]="'base.field.type_of_disability_relevant_to_care' | transloco">
			<mat-form-field lvrInput [attr.aria-label]="'base.field.select_please' | transloco">
				<mat-select
					#sel="matSelect"
					formControlName="careRelatedHandycapId"
					[placeholder]="'base.field.type_of_disability_relevant_to_care' | transloco"
				>
					<mat-select-trigger>
						{{ getDisabilityKindName(sel.value) }}
						<span class="text-sm differentiation">{{ getDisabilityKindDifferentiation(sel.value) }}</span>
					</mat-select-trigger>

					@for (option of disabilityKinds(); track option.id) {
						<mat-option class="option" [value]="option.id">
							<span class="remark">{{ option.disabilityType?.remark ?? '' }}</span>
							<span class="text-sm">{{ option.categoryDiagnosis?.description ?? '-' }}</span>
						</mat-option>
					}
				</mat-select>
			</mat-form-field>
		</lvr-field>

		<!-- Documents -->
		@let documentsCtrl = form.get('documents');
		<lvr-field
			[label]="
				documentsIsRequired
					? ('base.field.documents' | transloco | appendAsterisk)
					: ('base.field.documents' | transloco)
			"
		>
			<lvr-document-upload
				[maxFileCount]="maxFileCount"
				[hasError]="hasFileError(documentsCtrl, 'requiredFile', 'maxFiles', 'maxFileSize', 'allowedFileTypes')"
				[multiple]="true"
				[disabled]="!canManageAssignmentDocuments()"
				formControlName="documents"
				[showIcon]="true"
				[ownerId]="client()?.uuid ?? ''"
				[maxFileSize]="maxFileSize"
				[subjectType]="subjectType"
			>
			</lvr-document-upload>
		</lvr-field>
	</section>

	<p lvrPadding [padHorizontal]="0" [padVertical]="24">{{ 'base.form.required' | transloco }}</p>

	<!-- Actions -->
	<lvr-default-actions
		(cancelSave)="cancel()"
		[disableSave]="form.invalid || !canCreateAssignmentsPermission()"
		(save)="save()"
		[showLoading]="isLoading()"
	>
		<lvr-restore-actions entityType="additional" [entityId]="draftId"></lvr-restore-actions>
	</lvr-default-actions>
</form>
